import { ClientIdentityType } from 'api/types/data';

export const isPersonClientRepresentative = (type: ClientIdentityType) =>
  type === ClientIdentityType.ClientRepresentative;
